import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { Buffer } from 'buffer';
import { initSentry } from './config/sentry';
import { PostHogProvider } from 'posthog-js/react';

// Initialize Sentry first (before any other code runs)
initSentry();

// Note: Service worker registration is handled by UpdatePrompt.tsx component
// using useRegisterSW hook with autoUpdate mode

// Polyfill Buffer for browser
window.Buffer = Buffer;

const posthogOptions = {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
};

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <PostHogProvider
      apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY}
      options={posthogOptions}
    >
      <App />
    </PostHogProvider>
  </React.StrictMode>
);
